// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__INfuO","navlink":"Navigation_navlink__1GXEM","activeNavlink":"Navigation_activeNavlink__3I4IM Navigation_navlink__1GXEM"};